export const UNDELIVERABLE_EMAIL_MESSAGE =
  "We couldn't find a mail server for that email address. Check it for a typo and try again.";

export const SIGN_IN_CODE_RATE_LIMITED_MESSAGE =
  "Too many sign-in codes were requested. Please wait a few minutes and try again.";

export const SIGN_IN_CODE_UNDELIVERED_MESSAGE =
  "We couldn't deliver the code to that address. Check it for a typo or use a different email.";

export const SIGN_IN_CODE_DELIVERY = {
  PENDING: "pending",
  UNDELIVERABLE: "undeliverable",
} as const;
